import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { quoteFormSelector } from 'ctm-selectors';
import { convertStringCase } from 'ctm-components';
import moment from 'moment';
import { displayBooleanString } from 'ctm-util-functions';
import { QuoteCard } from '../quote_card';
import { QuoteQuestionPlainItem } from '../quote_question_plain_item';

export const getEmploymentLabel = (value) => ({
    EMPLOYED_FULL_TIME: 'Employed full-time',
    EMPLOYED_PART_TIME: 'Employed part-time',
    SELF_EMPLOYED: 'Self employed',
    RETIRED: 'Retired',
    STUDENT: 'Student',
    UNEMPLOYED: 'Unemployed',
    HOUSE_WIFE_OR_HUSBAND: 'Home duties'
}[value]);

const _RegularDriver = (props) => {
    const { driverGender, driverDob, driverEmployment, driverAge, comprehensiveInsured, comprehensiveInsuredYears,
        driverPreviousClaims, driverOwnsAnotherCar, driverOwnsAnotherHome } = props;
    return (
        <QuoteCard title="Regular driver" path="regular_driver_gender">
            <QuoteQuestionPlainItem title="Gender" content={convertStringCase(driverGender.toLowerCase(), 'title')} />
            <QuoteQuestionPlainItem title="Date of birth" content={moment(driverDob).format('DD/MM/YYYY')} />
            <QuoteQuestionPlainItem title="Employment" content={getEmploymentLabel(driverEmployment)} />
            <QuoteQuestionPlainItem title="Licence age" content={driverAge} />
            <QuoteQuestionPlainItem title="Past comprehensive car insurance" content={displayBooleanString(comprehensiveInsured)} />
            <QuoteQuestionPlainItem title="Years of comprehensive car insurance" content={comprehensiveInsuredYears} />
            <QuoteQuestionPlainItem title="Previous claims" content={displayBooleanString(driverPreviousClaims)} />
            <QuoteQuestionPlainItem title="Owns another car" content={displayBooleanString(driverOwnsAnotherCar)} />
            <QuoteQuestionPlainItem title="Owns a home" content={displayBooleanString(driverOwnsAnotherHome)} />

        </QuoteCard>
    );
};

_RegularDriver.propTypes = {
    driverGender: PropTypes.string,
    driverDob: PropTypes.string,
    driverEmployment: PropTypes.string,
    driverAge: PropTypes.string,
    comprehensiveInsured: PropTypes.bool,
    comprehensiveInsuredYears: PropTypes.string,
    driverPreviousClaims: PropTypes.string,
    driverOwnsAnotherCar: PropTypes.string,
    driverOwnsAnotherHome: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        driverGender: quoteFormSelector(state).getIn(['coverDetail', 'driver', 'gender']) || '',
        driverDob: quoteFormSelector(state).getIn(['coverDetail', 'driver', 'dob']),
        driverEmployment: quoteFormSelector(state).getIn(['coverDetail', 'driver', 'employmentStatus']),
        driverAge: quoteFormSelector(state).getIn(['coverDetail', 'driver', 'licenceAge']),
        comprehensiveInsured: quoteFormSelector(state).getIn(['coverDetail', 'driver', 'comprehensiveInsured']),
        comprehensiveInsuredYears: quoteFormSelector(state).getIn(['coverDetail', 'driver', 'comprehensiveInsuredYears']),
        driverPreviousClaims: quoteFormSelector(state).getIn(['coverDetail', 'driver', 'anyPreviousClaims']),
        driverOwnsAnotherCar: quoteFormSelector(state).getIn(['coverDetail', 'ownsAnotherCar']),
        driverOwnsAnotherHome: quoteFormSelector(state).getIn(['coverDetail', 'ownsHome'])
    };
};

const RegularDriver = connect(mapStateToProps)(_RegularDriver);

export { RegularDriver, _RegularDriver };
